<div
    class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-evenly sm:tw-p-6 tw-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-center sm:tw-items-center"
>
    <div
        class="tw-w-full sm:tw-w-[80%] lg:tw-w-[60%] xl:tw-w-[36%] tw-pt-4 tw-pb-10 tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2] tw-h-full sm:tw-h-auto"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                    [routerLink]="['/home']"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                        >{{ "LANG.EN" | translate }}</span
                    >
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                        >{{ "LANG.BM" | translate }}</span
                    >
                </div>
            </div>
        </header>
        <div
            class="tw-flex tw-flex-col tw-items-center tw-gap-[6vw] sm:tw-mt-[1rem] tw-px-[3rem] tw-flex-grow sm:tw-flex-grow-0 tw-justify-center sm:tw-justify-start"
        >
            <div class="tw-text-center">
                <img
                    src="../../../../assets/images/insurance/correct_badge.png"
                    alt="Correct Badge"
                    class="tw-w-[70px] tw-h-[70px] tw-mx-auto tw-mb-[2rem]"
                />
                <div class="tw-text-[20px] tw-font-bold">
                    {{ "COMMON.SUCCESS_REGISTRATION" | translate }}
                </div>
                <div class="tw-text-[18px] tw-font-medium tw-mt-4">
                    {{ "REGISTER.SUCCESS_REGISTER_DESCRIPTION" | translate }}
                </div>
                <div class="tw-font-bold tw-text-[16px] tw-text-[#8f8f8f] tw-mt-4">
                    {{ "COMMON.REDIRECTION" | translate }} {{ countdown }}s.
                </div>
                <button
                    ga-event-id="success_register_login_button_ssp_click"
                    ga-event-category="Sign Up Success Page Button"
                    ga-event-label="Success Register Button"
                    ga-track="track"
                    class="tw-mt-3 tw-rounded-[32px] tw-text-white tw-bg-[#FFA53C] tw-font-bold tw-h-[56px] tw-text-[16px] tw-py-[1rem] tw-px-[4rem]"
                    (click)="onSignIn()"
                >
                    {{ "COMMON.GO_TO_LOGIN" | translate }}
                </button>
            </div>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-absolute tw-left-0 tw-bottom-0"
        src="../../../../assets/images/login-signup/Blue-1.png"
        alt="Blue Img"
    />
</div>
